import { useAnticipationStatus } from "@/hooks/useAnticipationStatus.ts";
import { Button, Flex } from "@chakra-ui/react";

interface ExcludeChargeProps {
  handleToggleDeleteChargeModal: () => void
}

export function ExcludeCharge({ handleToggleDeleteChargeModal }: ExcludeChargeProps) {
  const { hasAntecipationActive } = useAnticipationStatus()
  return (
    <>
      <Flex flexDir="column" align="flex-start" >
        <Button
          p="0 16px"
          m="0"
          color={hasAntecipationActive ? "newGray.400" : "black"}
          fontWeight={hasAntecipationActive ? "normal" : "bold"}
          fontSize={hasAntecipationActive ? "14px" : "1rem"}
          disabled={hasAntecipationActive}
          id="excluir_cobrança"
          borderRadius="4px"
          border="1px solid #000000"
          background="white"
          boxShadow="0 2px 0 0 rgba(0, 0, 0, 0.04)"
          transition="filter .2s"
          cursor="pointer"
          _hover={!hasAntecipationActive ? {
            transition: "filter .2s",
            filter: "brightness(.8)",
            textDecoration: "underline",
            color: "black",
          } : {}}
          onClick={handleToggleDeleteChargeModal}
        >
          Excluir cobrança
        </Button>
      </Flex>
    </>
  )
}